(function ($, Promise) {

        // AudioPlayer handling class
        function AudioPlayer() {
            this.audios = [];
            this.volumeTl = false;
        }

        AudioPlayer.prototype.play = function (filename, forcePlay, callback, metadataCallback) {
            forcePlay = typeof forcePlay !== "undefined" ? forcePlay : false;
            callback = typeof callback !== "undefined" ? callback : false;

            // First check if the sound is already playing so we do not start it again
            var isPlaying = this.isPlaying(filename);

            if (isPlaying && !forcePlay) {
                console.log("Track already playing and no force play defined", filename, this.audios);
                return;
            }

            var randID = window.guid();
            var audio = document.createElement('audio');
            $(audio).attr("id", randID);
            $(audio).attr("preload", "none");

            // add the audio to the body so we can safely delete it later on
            $("body").append(audio);

            this.killVolumeTl();
            audio.src = filename;
            audio.volume = 1;

            $(audio).one("ended", $.proxy(function () {
                if (typeof this.audios[0].callback == "function") {
                    this.audios[0].callback();
                }
                this.clearTrack(randID);
            }, this));

            $(audio).one("loadedmetadata", $.proxy(function () {
                if (typeof this.audios[0].metadataCallback == "function") {
                    this.audios[0].metadataCallback(audio);
                }
            }, this));

            $(audio).one("error", $.proxy(function (e) {
                // if (typeof this.audios[0].callback == "function") {
                //     this.audios[0].callback();
                // }
                this.clearTrack(randID);
            }, this));

            audio.play();

            this.audios.push({
                el: audio,
                id: randID,
                filename: filename,
                callback: callback,
                metadataCallback: metadataCallback
            });

            // console.log("Will play", filename, this.audios);

            return this.audios[this.audios.length - 1];
        }

        AudioPlayer.prototype.clearTrack = function (id) {
            for (var i = 0; i < this.audios.length; i++) {

                if (this.audios[i].id == id) {

                    var $el = $("#" + id);
                    $el.attr("src", "");
                    $el.get(0).load();
                    $el.off().remove();

                    // console.log("Track cleared", id, this.audios[i].filename);
                    this.audios[i].id = false;
                    this.audios[i].el = false;
                    this.audios[i].filename = false;
                    this.audios[i].callback = false;
                    this.audios.splice(i, 1);
                    break;
                }
            }
        }

        AudioPlayer.prototype.clearAll = function (id) {
            for (var i = 0; i < this.audios.length; i++) {
                this.clearTrack(this.audios[i].id)
            }
        }

        AudioPlayer.prototype.isPlaying = function (filename) {
            var playing = false;

            for (var i = 0; i < this.audios.length; i++) {
                if (this.audios[i].filename == filename) {
                    playing = true;
                    break;
                }
            }

            return playing;
        };


        AudioPlayer.prototype.preload = function (audioFiles, callback) {

            var loaded = 0;

            for (var i in audioFiles) {
                var audio = new Audio();
                audio.preload = "auto";
                audio.muted = "muted";
                // audio.autobuffer = "auto";

                // once this file loads,
                // the file will be kept by the browser as cache
                audio.addEventListener('canplaythrough', function () {
                    // this will be called every time an audio file is loaded
                    // we keep track of the loaded files vs the requested files
                    loaded++;
                    // console.log("playthrough", loaded, audioFiles.length)
                    if (loaded == audioFiles.length) {
                        // all have loaded
                        if (typeof callback == "function") {
                            callback();
                        }
                    }
                }, false);

                audio.src = audioFiles[i];
                audio.load();
            }
        }

        // AudioPlayer.prototype.mute = function () {
        //     for (var i = 0; i < this.audios.length; i++) {
        //         var $el = $("#" + this.audios[i].id);
        //         TweenMax.to($el, 0.3, {
        //             volume: 0,
        //             onComplete: function() {
        //                 $el.get(0).pause();
        //             }
        //         });
        //     }
        // };
        //
        // AudioPlayer.prototype.unmute = function () {
        //     for (var i = 0; i < this.audios.length; i++) {
        //         var $el = $("#" + this.audios[i].id);
        //         $el.get(0).play();
        //         TweenMax.to($el, 0.3, {
        //             volume: 1,
        //         });
        //     }
        // };

        AudioPlayer.prototype.stop = function () {
            for (var i = 0; i < this.audios.length; i++) {
                var $el = $("#" + this.audios[i].id);

                this.killVolumeTl();

                this.volumeTl = TweenMax.to($el, 0.15, {
                    volume: 0,
                    onComplete: $.proxy(function () {
                        if (this.audios[i]) {
                            this.clearTrack(this.audios[i].id);
                            // $el.get(0).remove();
                        }
                    }, this)
                });
            }
        };

        AudioPlayer.prototype.killVolumeTl = function () {
            if (this.volumeTl != false) {
                this.volumeTl.kill();
                this.volumeTl = false;
            }
        };

        // Expose AudioPlayer
        window.AudioPlayer = AudioPlayer;

    }
)(jQuery, Promise);

